import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { BackLink } from "@/components/back-link";
import { PageHeader } from "@/components/page-header";
import { orpc } from "@/lib/orpc";
import { FaqItemForm, type FaqItemValues } from "./-components/faq-item-form";

export const Route = createFileRoute("/_admin/content/faq/new")({
	component: NewFaqItemPage,
});

/** Add a question; it goes to the bottom of the list, which the browser returns to. */
function NewFaqItemPage() {
	const { t } = useTranslation("faqItem");
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const create = useMutation({
		...orpc.faqItem.create.mutationOptions(),
		// The list is where this goes next: have it fresh, not the cached one without the new question.
		onSuccess: () => queryClient.invalidateQueries({ queryKey: orpc.faqItem.key(), refetchType: "all" }),
	});

	const onSubmit = async (values: FaqItemValues) => {
		await create.mutateAsync(values);
		await navigate({ to: "/content/faq" });
	};

	return (
		<div className="flex max-w-5xl flex-col gap-6">
			<PageHeader
				back={<BackLink to="/content/faq">{t("title")}</BackLink>}
				title={t("new.title")}
				description={t("new.description")}
			/>
			<FaqItemForm submitLabel={t("new.submit")} onSubmit={onSubmit} />
		</div>
	);
}
